import React from 'react';

type IconName =
  | 'add'
  | 'info'
  | 'warning'
  | 'check_circle'
  | 'error'
  | 'push_pin'
  | 'edit'
  | 'delete'
  | 'groups'
  | 'school'
  | 'science'
  | 'visibility'
  | 'schedule'
  | 'close';

interface IconProps {
  name: IconName;
  size?: number;
  className?: string;
}

const icons: Record<IconName, React.ReactNode> = {
  add: (
    <path d="M12 5v14M5 12h14" strokeWidth="2" strokeLinecap="round" />
  ),
  info: (
    <>
      <circle cx="12" cy="12" r="10" strokeWidth="2" />
      <path d="M12 16v-4M12 8h.01" strokeWidth="2" strokeLinecap="round" />
    </>
  ),
  warning: (
    <path d="M12 9v4M12 17h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  ),
  check_circle: (
    <>
      <circle cx="12" cy="12" r="10" strokeWidth="2" />
      <path d="M9 12l2 2 4-4" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </>
  ),
  error: (
    <>
      <circle cx="12" cy="12" r="10" strokeWidth="2" />
      <path d="M15 9l-6 6M9 9l6 6" strokeWidth="2" strokeLinecap="round" />
    </>
  ),
  push_pin: (
    <path d="M12 2v4M8 6h8l-1 6h-6l-1-6zM9 12l-2 8M15 12l2 8M7 22h10" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  ),
  edit: (
    <path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7M18.5 2.5a2.121 2.121 0 113 3L12 15l-4 1 1-4 9.5-9.5z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  ),
  delete: (
    <path d="M3 6h18M8 6V4a2 2 0 012-2h4a2 2 0 012 2v2M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6M10 11v6M14 11v6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  ),
  groups: (
    <>
      <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <circle cx="9" cy="7" r="4" strokeWidth="2" />
      <path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </>
  ),
  school: (
    <path d="M22 10v6M2 10l10-5 10 5-10 5-10-5zM6 12v5c0 1.657 2.686 3 6 3s6-1.343 6-3v-5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  ),
  science: (
    <path d="M9 3h6M10 3v7l-5 8.5a1.5 1.5 0 001.3 2.25h11.4a1.5 1.5 0 001.3-2.25L14 10V3M8.5 14h7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  ),
  visibility: (
    <>
      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <circle cx="12" cy="12" r="3" strokeWidth="2" />
    </>
  ),
  schedule: (
    <>
      <circle cx="12" cy="12" r="10" strokeWidth="2" />
      <path d="M12 6v6l4 2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </>
  ),
  close: (
    <path d="M18 6L6 18M6 6l12 12" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  ),
};

const Icon: React.FC<IconProps> = ({ name, size = 20, className = '' }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      className={className}
      style={{ display: 'inline-block', verticalAlign: 'middle' }}
    >
      {icons[name]}
    </svg>
  );
};

export default Icon;
